/**
 * TOP FROG PRODUCT INTERACTIONS
 * Custom product-page enhancements layered over Shopify Dawn.
 */

(() => {
  const initializedGalleries = new WeakSet();

  class TopFrogGalleryTransition {
    constructor(gallery) {
      this.gallery = gallery;
      this.activeMedia = this.getActiveMedia();
      this.cleanupTimer = null;

      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleGalleryMutation = this.handleGalleryMutation.bind(this);
    }

    getActiveMedia() {
      return this.gallery.querySelector('[data-media-id].is-active');
    }

    init() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      document.addEventListener('change', this.handleVariantChange, true);

      this.observer = new MutationObserver(this.handleGalleryMutation);

      this.gallery
        .querySelectorAll('[data-media-id]')
        .forEach((media) => {
          this.observer.observe(media, {
            attributes: true,
            attributeFilter: ['class'],
          });
        });
    }

    handleVariantChange(event) {
      if (!event.target.closest('variant-selects')) return;

      const currentMedia = this.getActiveMedia();
      if (!currentMedia) return;

      currentMedia.classList.add('tf-media-is-leaving');

      window.clearTimeout(this.cleanupTimer);

      this.cleanupTimer = window.setTimeout(() => {
        currentMedia.classList.remove('tf-media-is-leaving');
      }, 1200);
    }

    handleGalleryMutation() {
      const newActiveMedia = this.getActiveMedia();

      if (!newActiveMedia || newActiveMedia === this.activeMedia) return;

      this.gallery
        .querySelectorAll(
          '.tf-media-is-leaving, .tf-media-is-entering'
        )
        .forEach((media) => {
          media.classList.remove(
            'tf-media-is-leaving',
            'tf-media-is-entering'
          );
        });

      newActiveMedia.classList.add('tf-media-is-entering');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newActiveMedia.classList.remove('tf-media-is-entering');
        });
      });

      this.activeMedia = newActiveMedia;
    }
  }

  function initializeTopFrogProductInteractions(container = document) {
    container.querySelectorAll('media-gallery').forEach((gallery) => {
      if (initializedGalleries.has(gallery)) return;

      initializedGalleries.add(gallery);
      new TopFrogGalleryTransition(gallery).init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeTopFrogProductInteractions();
    });
  } else {
    initializeTopFrogProductInteractions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeTopFrogProductInteractions(event.target);
  });
})();